import React from 'react';

import { connect } from 'react-redux';

import { Link } from 'react-router-dom';

import { createEvent } from '../actions';

const EventForm = (props) => {

    let fields = {};
    if (props.fields) {
        fields = props.fields;
    }

   return <section className="form">
       <div className="container container-md">
           <div className="form-header">
               <div className="text-center">
                   <h1><Link to="/events" className="ml-2"><i
                       className="fa-light fa-arrow-left small"></i></Link> {fields.id ? 'Redigera' : 'Lägg till'} aktivitet</h1>
               </div>
           </div>
           {props.saved && <div>
               <div className="alert alert-success">Aktiviteten sparad!</div>
               <section className="text-center">
                   <Link to="/events">Tillbaka till aktiveter</Link> eller <Link to="/events/add">Lägg till en ny aktivitet</Link>
               </section>
           </div>}
           {!props.saved && <div>
               {props.fields.contracts > 0 && <div className="alert alert-warning">
                   Det finns registrerade kontrakt på den här aktiviteten.<br />
                   Ändringar i avtal påverkar endast framtida kontrakt.
               </div>}
               <form>
               <div className="form-group">
                   <label>Typ</label>
                   <div className="select" >
                       <select className="form-control" onChange={props.onFieldChange.bind(null, 'type')} value={fields.type}>
                           <option value="0">Välj...</option>
                           <option value="1">Fotografering</option>
                           <option value="2">Filmning</option>
                       </select>
                   </div>
               </div>
               <div className="form-group">
                   <label>Titel</label>
                   <input type="text" className="form-control" placeholder="Ex: fotografering i stan" onChange={props.onFieldChange.bind(null, 'title')} value={fields.title} />
               </div>
               <div className="form-group">
                   <label>Kundens namn</label>
                   <input type="text" className="form-control" placeholder="" onChange={props.onFieldChange.bind(null, 'client')} value={fields.client} />
               </div>
               <div className="form-group">
                   <label>Internt referensnummer</label>
                   <input type="text" className="form-control" onChange={props.onFieldChange.bind(null, 'reference')} placeholder="Ex: XXX001" value={fields.reference} />
               </div>
               <div className="form-group">
                   <label>Ersättning</label>
                   <input type="text" className="form-control" onChange={props.onFieldChange.bind(null, 'compensation')} placeholder="Anges i kronor" value={fields.compensation} />
               </div>
               <div className="form-group">
                   <label>Giltighetstid</label>
                   <input type="number" className="form-control" onChange={props.onFieldChange.bind(null, 'validYears')} placeholder="Ange antal år som kontrakt ska gälla" value={fields.validYears} />
               </div>
               <div className="form-group">
                   <label>Avtalsvillkor</label>
                   <textarea className="form-control" rows="8" onChange={props.onFieldChange.bind(null, 'eula')} value={fields.eula} />
               </div>
           </form>
               {props.status == 400 && <div className="alert alert-warning">
                   Var vänlig och fyll i samtliga fält.
               </div>}
               {props.status == 401 && <div className="alert alert-danger">
                   Det gick inte att spara
               </div>}
               <div className="form-footer text-center">
                   <button type="submit" onClick={props.onSubmit}
                           className="btn btn-success btn-lg">Spara
                   </button>
               </div>
           </div>}

       </div>
   </section>
}

export default connect(state => state.eventFormState, (dispatch) => {
    return {
        onFieldChange: (field, e) => {
            dispatch({
                type: 'EVENT_FIELD_CHANGE',
                field: field,
                value: e.target.value
            })
        },
        onSubmit: () => {
            createEvent(dispatch);
        }
    }
})(EventForm);